var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-item"},_vm._l((_vm.filterList),function(filterItem,index){return _c('span',{key:'filter_' + index},[_c('label',[_c(_vm.component,{tag:"component",attrs:{"filter-item":filterItem,"selected-items":_vm.selectedItems,"get-current-adult-flag-fn":_vm.getCurrentAdultFlag}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }